import { GridCellParams, GridRenderEditCellParams } from '@mui/x-data-grid-premium';
import { GridColDef } from '@mui/x-data-grid-pro';
import clsx from 'clsx';
import { find, isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import AutocompleteEditCell from '../../../lab/money/AutocompleteEditCell';
import { AutocompleteOption } from '../../form/widgets/OptionRendererProps';
import { useI18n } from '../../i18n/I18n';
import { UseCalculationTypeColDefProps } from './UseColDefProps';

export default (props: UseCalculationTypeColDefProps): GridColDef => {
    const { prop, width, readOnly = false, flex = 0, calculationTypes, rates, onChange } = props;
    const header = useI18n(`grid.header.${prop}`);

    const options: AutocompleteOption[] = useMemo(() => {
        const availableRates = rates && { ...rates.calculationType, itemPrice: rates.itemPrice };

        return calculationTypes
            ? calculationTypes.map((t) => {
                  const itemPrice = availableRates?.itemPrice;
                  return { id: t.code, label: t.label, ratePrice: itemPrice?.units || '' };
              })
            : [];
    }, [calculationTypes, rates]);

    return {
        field: prop,
        headerName: header,
        editable: !readOnly,
        flex: flex,
        width: width,
        type: 'string',
        cellClassName: (params: GridCellParams) => {
            return clsx(prop, { isEmpty: !readOnly && isEmpty(params.value) });
        },
        valueFormatter: (value) => {
            // const row = params.api.getRow(params.id);
            const option = find(options, { id: value });
            return option ? option.label : '';
        },
        renderEditCell: (params: GridRenderEditCellParams) => (
            <AutocompleteEditCell
                id={params.id}
                field={params.field}
                value={params.value}
                options={options}
                freeSolo={false}
                multiple={false}
                onChange={onChange}
                disableClearable
            />
        )
    };
};
